import routerOptions0 from "/builds/b2ag/fronts/front-b2ag/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-proposal-decorators@7.29.0_@babel+core@7.29.0__@babel+plugin-s_962ef69811db35c2b4e9c52a770300b9/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/b2ag/fronts/front-b2ag/front/core/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}